module.exports = __webpack_public_path__ + "img/blue_bay_bedroom.e8058b3f.jpeg";